import { render, staticRenderFns } from "./LpContacts.vue?vue&type=template&id=1fb6274e"
import script from "./LpContacts.vue?vue&type=script&lang=js"
export * from "./LpContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports